import { initializeApp, getApps, getApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getMessaging, getToken, deleteToken } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: "AIzaSyCtF2G-UNhQyqE9LkG8QLu9Vsh6lXAIw9I",
  authDomain: "quary-notification.firebaseapp.com",
  projectId: "quary-notification",
  storageBucket: "quary-notification.firebasestorage.app",
  messagingSenderId: "623869932755",
  appId: "1:623869932755:web:4b9b5fe1994631c6a91026",
  measurementId: "G-3CY3P8F940"
}

// Firebase app initialization
const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
export const db = getFirestore(app)

export const getMessagingInstance = () => {
  if (typeof window === 'undefined') return null
  try {
    return getMessaging(app)
  } catch (err) {
    console.log('Error getting messaging instance', err)
    return null
  }
}

// ✅ Login/Signup ke time call karo
export const generateAndSaveFCMToken = async () => {
  const messaging = getMessagingInstance()
  if (!messaging) return

  try {
    const token = await getToken(messaging, {
      vapidKey: "BH-IGrdHNoCEePkWOvuW5BKQJ4iGTlN_8zkQlOC2lugbvfYsRk1j07dZi1GoaZh4kyopWBPMd45tpaavKF2SLzg"
    })

    if (token) {
      localStorage.setItem('fcm_token', token)
      console.log("FCM Token generated:", token)
    }

    return token
  } catch (err) {
    console.error("FCM Token Error:", err)
  }
}

// ✅ Logout ke time call karo
export const removeFCMToken = async () => {
  const messaging = getMessagingInstance()
  if (!messaging) return

  try {
    await deleteToken(messaging)
    localStorage.removeItem('fcm_token')
    console.log("FCM Token removed")
  } catch (err) {
    console.error("FCM Token remove error:", err)
  }
}